<template>
    <div class="dropdown">
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
                <a
                    :class="['nav-link', 0 == isActive ? 'active' : '']"
                    @click="changeTab(0)"
                    href="#login"
                    role="tab"
                    >Ingreso sesión</a
                >
            </li>

            <li class="nav-item">
                <a
                    :class="['nav-link', 4 == isActive ? 'active' : '']"
                    @click="changeTab(4)"
                    href="#proyectinfo"
                    role="tab"
                    >Información general del proyecto</a
                >
            </li>

            <li class="nav-item">
                <a
                    :class="['nav-link', 5 == isActive ? 'active' : '']"
                    @click="changeTab(5)"
                    href="#business"
                    role="tab"
                    >Resultados</a
                >
            </li>

            <li class="nav-item">
                <a
                    :class="['nav-link', 6 == isActive ? 'active' : '']"
                    @click="changeTab(6)"
                    href="#team"
                    role="tab"
                    >Equipo</a
                >
            </li>
            <li class="nav-item">
                <a
                    :class="['nav-link', 7 == isActive ? 'active' : '']"
                    @click="changeTab(7)"
                    href="#summary"
                    role="tab"
                    >Resumen</a
                >
            </li>
            <li class="nav-item dropdown">
                <a
                    class="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                    href="#"
                    aria-expanded="true"
                    >Mas ...</a
                >
                <div
                    class="dropdown-menu"
                    x-placement="top-start"
                    style="
                        position: absolute;
                        will-change: transform;
                        top: 0px;
                        left: 0px;
                        transform: translate3d(0px, -185px, 0px);
                    "
                >
                    <a
                        :class="[
                            'dropdown-item',
                            2 == isActive ? 'active' : '',
                        ]"
                        @click="changeTab(2)"
                        href="#what"
                        role="tab"
                        >Que informacion necesitamos</a
                    >
                    <a
                        :class="[
                            'dropdown-item',
                            14 == isActive ? 'active' : '',
                        ]"
                        @click="changeTab(14)"
                        href="#image"
                        role="tab"
                        >Imagenes registro proyecto</a
                    >
                    <a
                        :class="[
                            'dropdown-item',
                            8 == isActive ? 'active' : '',
                        ]"
                        @click="changeTab(8)"
                        href="#tipsvideor"
                        role="tab"
                        >Tips de video</a
                    >
                    <a
                        :class="[
                            'dropdown-item',
                            9 == isActive ? 'active' : '',
                        ]"
                        @click="changeTab(9)"
                        href="#tipsphoto"
                        role="tab"
                        >Tips de foto</a
                    >
                    <a
                        :class="[
                            'dropdown-item',
                            10 == isActive ? 'active' : '',
                        ]"
                        @click="changeTab(10)"
                        href="#successful"
                        role="tab"
                        >Registro exitoso</a
                    >
                    <a
                        :class="[
                            'dropdown-item',
                            15 == isActive ? 'active' : '',
                        ]"
                        @click="changeTab(15)"
                        href="#example"
                        role="tab"
                        >Tips ejemplo</a
                    >
                </div>
            </li>
        </ul>

        <div class="tab-content">
            <div
                :class="['tab-pane', 0 == isActive ? 'active' : '']"
                id="login"
                role="tabpanel"
            >
                <project-Login-component
                    v-if="0 == isActive"
                ></project-Login-component>
            </div>
            <div
                :class="['tab-pane', 2 == isActive ? 'active' : '']"
                id="what"
                role="tabpanel"
            >
                <project-what-information-component
                    v-if="2 == isActive"
                ></project-what-information-component>
            </div>
            <div
                :class="['tab-pane', 4 == isActive ? 'active' : '']"
                id="proyectinfo"
                role="tabpanel"
            >
                <project-information-project-component
                    v-if="4 == isActive"
                ></project-information-project-component>
            </div>
            <div
                :class="['tab-pane', 5 == isActive ? 'active' : '']"
                id="business"
                role="tabpanel"
            >
                <project-business-model-component
                    v-if="5 == isActive"
                ></project-business-model-component>
            </div>
            <div
                :class="['tab-pane', 6 == isActive ? 'active' : '']"
                id="team"
                role="tabpanel"
            >
                <project-team-component
                    v-if="6 == isActive"
                ></project-team-component>
            </div>
            <div
                :class="['tab-pane', 7 == isActive ? 'active' : '']"
                id="summary"
                role="tabpanel"
            >
                <project-summary-component
                    v-if="7 == isActive"
                ></project-summary-component>
            </div>
            <div
                :class="['tab-pane', 8 == isActive ? 'active' : '']"
                id="tipsvideo"
                role="tabpanel"
            >
                <project-tips-video-component
                    v-if="8 == isActive"
                ></project-tips-video-component>
            </div>
            <div
                :class="['tab-pane', 9 == isActive ? 'active' : '']"
                id="tipsphoto"
                role="tabpanel"
            >
                <project-tips-photo-component
                    v-if="9 == isActive"
                ></project-tips-photo-component>
            </div>
            <div
                :class="['tab-pane', 10 == isActive ? 'active' : '']"
                id="successful"
                role="tabpanel"
            >
                <project-successful-component
                    v-if="10 == isActive"
                ></project-successful-component>
            </div>
            <div
                :class="['tab-pane', 11 == isActive ? 'active' : '']"
                id="mate"
                role="tabpanel"
            >
                <project-team-mate-component
                    v-if="11 == isActive"
                ></project-team-mate-component>
            </div>
            <div
                :class="['tab-pane', 12 == isActive ? 'active' : '']"
                id="mateSuccessful"
                role="tabpanel"
            >
                <project-team-mate-successful-component
                    v-if="12 == isActive"
                ></project-team-mate-successful-component>
            </div>
            <div
                :class="['tab-pane', 13 == isActive ? 'active' : '']"
                id="complete"
                role="tabpanel"
            >
                <project-inscription-complete-component
                    v-if="13 == isActive"
                ></project-inscription-complete-component>
            </div>
            <div
                :class="['tab-pane', 14 == isActive ? 'active' : '']"
                id="image"
                role="tabpanel"
            >
                <project-image-register-component
                    v-if="14 == isActive"
                ></project-image-register-component>
            </div>
            <div
                :class="['tab-pane', 15 == isActive ? 'active' : '']"
                id="image"
                role="tabpanel"
            >
                <project-tips-example-component
                    v-if="15 == isActive"
                ></project-tips-example-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tab: 0,
        };
    },
    computed: {
        isActive: function () {
            return this.tab;
        },
    },
    methods: {
        changeTab(value) {
            if (this.tab != value) {
                this.tab = value;
            }
        },
    },
    mounted() {},
};
</script>
